import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import { HuntGroupFormComponent } from '././HuntGroupForm'
import { showPhoneSystemHuntGroupEditFormModal } from 'features/PhoneSystem/PhoneSystemHuntGroupEditFormModal'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    ...otherProps.initialValues,
    timeout: 15,
  },
})

export const dispatchToProps = {
  showPhoneSystemHuntGroupEditFormModal,
}

export const HuntGroupForm = connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(HuntGroupFormComponent)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/HuntGroup/HuntGroupForm.container.js